module.exports = __webpack_public_path__ + "img/ICONE-BANNIERE.6da7309c.svg";